/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Container, Grid, SvgIcon, Typography } from "@material-ui/core";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import globalColors from "../../../../../_metronic/_assets/sass/custom/globalColors.scss";
import { ReactComponent as lawsuit } from "../../../../assets/icons/lawsuit.svg";
import InputForm from "../../../../components/InputForm";
import { AppAPIService } from "../../../../services/AppAPIService";
import store from "../../../../store/store";
import { FormatMoney } from "../../../../utils/FormatMoney";
import FormatNumberLawsuit from "../../../../utils/FormatNumberLawsuit";
import Loading from "../../../home/components/Loading";
import FormActions from "../../components/FormActions";
import styles from "./styles.module.scss";

const LawsuitForm = () => {
  let api = AppAPIService.getInstance();
  const history = useHistory();
  const { auth } = store.getState();
  const [loading, setLoading] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const debounce = (func, delay) => {
    let timerId;

    return function (...args) {
      if (timerId) {
        clearTimeout(timerId);
      }

      timerId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  };

  /* companyName */
  const [companyName, setCompanyName] = useState("");
  const [companyNameRole, setCompanyNameRole] = useState("ok");
  const [companyNameError, setCompanyNameError] = useState("");
  const handleInputCompanyName = (companyName) => {
    if (!companyName) {
      setCompanyName();
      setCompanyNameError("Campo obrigatório");
      setCompanyNameRole("notOk");
    } else {
      setCompanyName(companyName);
      setCompanyNameError("");
      setCompanyNameRole("ok");
    }
  };
  /* end companyName*/

  // actionsList
  const [action, setAction] = useState("");
  const [searchAction, setSearchAction] = useState("");
  const [actionError, setActionError] = useState("");
  const [actionRole, setActionRole] = useState("");
  const [actionsList, setActionsList] = useState([]);

  const handleSearchActions = useCallback(async (search) => {
    setIsLoading(true);
    try {
      const response = await api.makeHttpRequest({
        url: `/action/list-paginated`,
        params: {
          search,
          page: 1,
          perPage: 1000,
        },
      });
      const actions = response.data.map((resp) => ({
        value: resp.id,
        label: resp.action,
      }));
      setActionsList(actions);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const debouncedSearchActions = useCallback(
    debounce(handleSearchActions, 300),
    [handleSearchActions]
  );

  const handleInputAction = (e) => {
    let value = e;
    if (e?.target?.value) {
      value = e.target.value;
    }

    setSearchAction(value);

    if (!value) {
      setAction("");
      setActionError("Campo obrigatório");
      setActionRole("notOk");
    } else {
      setAction(value);
      setActionError("");
      setActionRole("ok");
    }
  };

  useEffect(() => {
    debouncedSearchActions(searchAction);
  }, [searchAction, debouncedSearchActions]);

  useEffect(() => {
    handleSearchActions();
  }, []);

  // end actionsList

  /* adverseParty */
  const [adverseParty, setAdverseParty] = useState("");
  const [adversePartyRole, setAdversePartyRole] = useState("");
  const [adversePartyError, setAdversePartyError] = useState("");
  const handleInputAdverseParty = (e) => {
    if (overLimitInput(e, 100)) return;
    if (!e) {
      setAdverseParty();
      setAdversePartyError("");
      setAdversePartyRole("notOk");
    } else {
      setAdverseParty(e);
      setAdversePartyError("");
      setAdversePartyRole("ok");
    }
  };
  /* end adverseParty*/

  /* courtCaseNumber */
  const [courtCaseNumber, setCourtCaseNumber] = useState("");
  const [courtCaseNumberRole, setCourtCaseNumberRole] = useState("");
  const [courtCaseNumberError, setCourtCaseNumberError] = useState("");
  const handleInputCourtCaseNumber = (e) => {
    if (overLimitInput(e, 20)) return;

    if (!e) {
      setCourtCaseNumber();
      setCourtCaseNumberError("");
      setCourtCaseNumberRole("notOk");
    } else {
      setCourtCaseNumber(FormatNumberLawsuit(e));
      setCourtCaseNumberError("");
      setCourtCaseNumberRole("ok");
    }
  };
  /* end courtCaseNumber*/

  /* value */
  const [value, setValue] = useState("");
  const [valueRole, setValueRole] = useState("");
  const [valueError, setValueError] = useState("");
  const handleInputValue = (e) => {
    if (!e) {
      setValue();
      setValueError("");
      setValueRole("notOk");
    } else {
      if (overLimitInput(e, 20)) return;

      setValue(FormatMoney(e));
      setValueError("");
      setValueRole("ok");
    }
  };
  /* end value*/

  /* distributionDate */
  const [distributionDate, setDistributionDate] = useState("");
  const [distributionDateRole, setDistributionDateRole] = useState("");
  const [distributionDateError, setDistributionDateError] = useState("");
  const handleInputDistributionDate = (e) => {
    if (!e) {
      setDistributionDate();
      setDistributionDateError("");
      setDistributionDateRole("notOk");
    } else {
      setDistributionDate(e);
      setDistributionDateError("");
      setDistributionDateRole("ok");
    }
  };
  /* end distributionDate*/

  /* limitDate */
  const [limitDate, setLimitDate] = useState("");
  const [limitDateRole, setLimitDateRole] = useState("");
  const [limitDateError, setLimitDateError] = useState("");
  const handleInputLimitDate = (e) => {
    if (!e) {
      setLimitDate();
      setLimitDateError("");
      setLimitDateRole("notOk");
    } else {
      setLimitDate(e);
      setLimitDateError("");
      setLimitDateRole("ok");
    }
  };
  /* end limitDate*/

  /* billingAlert */
  const [billingAlert, setBillingAlert] = useState(2);
  const [billingAlertRole, setBillingAlertRole] = useState("");
  const [billingAlertError, setBillingAlertError] = useState("");
  const handleInputBillingAlert = (e) => {
    if (overLimitInput(e, 6)) return;
    if (!e) {
      setBillingAlert();
      setBillingAlertError("");
      setBillingAlertRole("notOk");
    } else {
      setBillingAlert(e);
      setBillingAlertError("");
      setBillingAlertRole("ok");
    }
  };
  /* end billingAlert*/

  /* user */
  const [user, setUser] = useState("");
  const [searchUser, setSearchUser] = useState("");
  const [userRole, setUserRole] = useState("");
  const [userError, setUserError] = useState("");

  const handleSearchUsers = useCallback(
    async (e) => {
      setIsLoading(true);
      try {
        const response = await api.makeHttpRequest({
          url: `/user/list-paginated`,
          params: {
            search: e,
            optionFilter: "CLIENT",
            page: 1,
            perPage: 1000,
          },
        });
        const clients = response.data.map((resp) => ({
          value: resp,
          label: resp.username,
        }));

        setUsersList(clients);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    },
    [setUsersList, api]
  );

  const debouncedSearchUsers = useCallback(debounce(handleSearchUsers, 300), [
    handleSearchUsers,
  ]);

  useEffect(() => {
    debouncedSearchUsers(searchUser);
  }, [searchUser, debouncedSearchUsers]);

  const handleInputUser = (e) => {
    let value = e;
    if (e?.target?.value) {
      value = e.target.value;
    }

    setSearchUser(value);

    if (!value?.label) {
      setUser("");
      setUserError("Campo obrigatório");
      setUserRole("notOk");
    } else {
      setUser(value);
      setUserError("");
      setUserRole("ok");
    }
  };

  useEffect(() => {
    handleSearchUsers();
  }, []);

  useEffect(() => {
    if (searchUser && searchUser.length > 3) {
      handleSearchUsers();
    }
  }, [searchUser, handleSearchUsers]);

  /* end user*/

  /* form validation */
  const formIsValid = useCallback(() => {
    let validForm = true;

    validForm =
      user !== "" &&
      userRole === "ok" &&
      adverseParty !== "" &&
      adversePartyRole === "ok" &&
      limitDate !== "" &&
      limitDateRole === "ok" &&
      action !== "" &&
      actionRole === "ok";

    return validForm;
  }, [
    user,
    userRole,
    adverseParty,
    adversePartyRole,
    limitDate,
    limitDateRole,
  ]);

  /* end form validation */
  /* submit */
  const submit = useCallback(
    async (e) => {
      e.preventDefault();
      try {
        setLoading(true);
        await api.makeHttpRequest({
          url: `/lawsuit`,
          method: "POST",
          data: {
            companyName: user?.value.username,
            document: user?.value.cpfCnpj ?? "",
            adverseParty,
            courtCaseNumber,
            actionId: action?.value,
            value: value
              ? value
                  .replace("R$", "")
                  .replace(".", "")
                  .replace(",", ".")
                  .trim()
              : "",
            distributionDate: moment(distributionDate).utc().format(),
            limitDate: moment(limitDate)
            .set("h", 3)
            .utc()
            .format("YYYY-MM-DD HH:mm:ss"),
            billingAlert: billingAlert ? parseInt(billingAlert) : 0,
            userId: user?.value.id,
            status: 1,
          },
        });
        Swal.fire({
          icon: "success",
          title: "Sucesso!",
          text: "Processo criado com sucesso.",
        }).then(() => {
          history.push("/admin/processo");
        });
      } catch (error) {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Erro ao criar processo.",
        });
      } finally {
        setLoading(false);
      }
    },
    [
      companyName,
      history,
      api,
      auth.token,
      auth.user,
      adverseParty,
      courtCaseNumber,
      action,
      value,
      distributionDate,
      limitDate,
      user,
      billingAlert,
    ]
  );
  /* end submit */

  /* clean form */
  const onCleanForm = async () => {
    setCompanyName("");
    setCompanyName("");
    setAdverseParty("");
    setCourtCaseNumber("");
    setValue("");
    setDistributionDate("");
    setLimitDate("");
    setBillingAlert("");
    setUser("");
    setUserError("");
    setUserRole("");
    setAdversePartyError("");
    setAdversePartyRole("");
    setCourtCaseNumberError("");
    setCourtCaseNumberRole("");
    setValueError("");
    setValueRole("");
    setDistributionDateError("");
    setDistributionDateRole("");
    setLimitDateError("");
    setLimitDateRole("");
    setBillingAlertError("");
    setBillingAlertRole("");
    setAction("");
    setActionError("");
    setActionRole("");
    setUsersList([]);
  };
  /* end clean form */

  const overLimitInput = (e, limit) => {
    if (e.length > limit) {
      return true;
    }
    return false;
  };

  return (
    <div className={styles.container}>
      <Loading isLoading={loading} />
      <Container
        maxWidth="xl"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          width: "100%",
          marginRight: "20px",
          padding: 0,
          color: globalColors.backgroundColor2,
          backgroundColor: `${globalColors.backgroundColor4}`,
          borderRadius: "4px",
        }}
      >
        <Container
          maxWidth="xl"
          style={{
            width: "100%",
            margin: 0,
            padding: 0,
            display: "flex",
            alignItems: "center",
            height: "48px",
            marginTop: "2px",
          }}
        >
          <SvgIcon
            component={lawsuit}
            stroke={globalColors.primaryColor5}
            style={{
              fontSize: "24px",
              marginRight: "12px",
              marginLeft: "20px",
              fill: "none",
              fontWheight: "600",
            }}
          />
          <Typography
            variant="p"
            style={{
              fontSize: "18px",
              fontWeight: "600",
              fontFamily: "Open Sans",
              fontStyle: "normal",
            }}
          >
            Cadastrar Processo
          </Typography>
        </Container>
      </Container>

      <form
        className={styles.form}
        style={{
          marginTop: "24px",
        }}
        autoComplete="off"
      >
        <div className={styles.containerInputs}>
          <Grid
            container
            spacing={1}
            style={{ width: "100%", margin: 0, padding: 0 }}
          >
            <Grid item xl={6} lg={6} md={6} sm={6}>
              <InputForm
                isSelect={true}
                name="user"
                placeholder="Selecione o cliente"
                label={"Cliente *"}
                value={user}
                onChange={handleInputUser}
                onKeyDown={(value) => handleInputUser(value)}
                error={userError}
                isRequired={true}
                role={userRole}
                options={usersList}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={6}>
              <InputForm
                type="text"
                name="adverseParty"
                placeholder="Digite as parte adversa"
                label={"Parte Adversa *"}
                value={adverseParty}
                error={adversePartyError}
                onChange={handleInputAdverseParty}
                role={adversePartyRole}
              />
            </Grid>
          </Grid>
        </div>
        <div className={styles.containerInputs}>
          <Grid
            container
            spacing={1}
            style={{ width: "100%", margin: 0, padding: 0 }}
          >
            <Grid item xl={2} lg={2} md={2} sm={2}>
              <InputForm
                type="text"
                name="courtCaseNumber"
                placeholder="Digite o número do processo"
                label={"Número do Processo"}
                value={courtCaseNumber}
                error={courtCaseNumberError}
                onChange={handleInputCourtCaseNumber}
                role={courtCaseNumberRole}
              />
            </Grid>
            <Grid item xl={5} lg={5} md={5} sm={5}>
              <InputForm
                type="text"
                name="action"
                placeholder="Selecione a ação"
                label="Ação *"
                required={true}
                value={action}
                onChange={handleInputAction}
                onKeyDown={(value) => handleInputAction(value)}
                error={actionError}
                role={actionRole}
                options={actionsList}
                isSelect={true}
              />
            </Grid>
            <Grid item xl={5} lg={5} md={5} sm={5}>
              <InputForm
                type="text"
                name="value"
                placeholder="Digite o valor"
                label={"Valor do Processo"}
                value={value}
                error={valueError}
                onChange={handleInputValue}
                role={valueRole}
              />
            </Grid>
          </Grid>
        </div>
        <div className={styles.containerInputs}>
          <Grid
            container
            spacing={1}
            style={{ width: "100%", margin: 0, padding: 0 }}
          >
            <Grid item xl={2} lg={2} md={2} sm={2}>
              <InputForm
                type="date"
                name="distributionDate"
                placeholder="Digite a data de distribuição"
                label={"Data de distribuição"}
                value={distributionDate}
                error={distributionDateError}
                onChange={handleInputDistributionDate}
                role={distributionDateRole}
              />
            </Grid>
            <Grid item xl={5} lg={5} md={5} sm={5}>
              <InputForm
                type="date"
                name="limitDate"
                placeholder="Digite a data limite"
                label={"Data limite *"}
                value={limitDate}
                error={limitDateError}
                onChange={handleInputLimitDate}
                role={limitDateRole}
              />
            </Grid>
            <Grid item xl={5} lg={5} md={5} sm={5}>
              <InputForm
                type="number"
                name="billingAlert"
                placeholder="Digite a frequêcia dos alertas"
                label={"Alertas de Cobrança (em dias) *"}
                value={billingAlert}
                error={billingAlertError}
                onChange={handleInputBillingAlert}
                role={billingAlertRole}
              />
            </Grid>
          </Grid>
        </div>
        <FormActions
          module={"processo"}
          formIsValid={formIsValid()}
          onCleanForm={onCleanForm}
          onSubmit={submit}
          hideCancel={true}
          messagem
        />
      </form>
    </div>
  );
};
export default LawsuitForm;
